'use es6';

import debounce from 'react-utils/debounce';
import { ImageAlignmentClasses } from 'rich-text-lib/constants/image';
import { Alignments } from 'rich-text-lib/constants/alignments';
import { getPluginSetting } from '../utils';
import { isEditableImage } from '../utils/image';
import { getResizeImageHandler, getUpdateMarginHandler, getLayoutChangeHandlerV2 } from './handlers';
import { trackInteraction } from '../utils/usageTracking';
import { AUTOMATIC_IMAGE_UPLOAD_NOT_ALLOWED } from '../constants/usageTracking';
export function addEventListeners(editor, openDisallowedImageUploadAlert) {
  const resizeImage = getResizeImageHandler(editor);
  editor.on('ObjectResized ObjectResizeStart', resizeImage);
  let parentLinkNode;
  let dragImgTarget;

  // Keep track of single child image / icon drag targets with a link parent
  editor.on('dragStart', evt => {
    const {
      target
    } = evt;
    if (target.nodeName !== 'IMG') return;
    if (target.parentNode.nodeName === 'A' && target.parentNode.children.length === 1) {
      parentLinkNode = target.parentNode;
      dragImgTarget = target;
    }
  });

  // Keep track of end of drag event to ensure link parent is not removed from single child icon / image
  editor.on('dragEnd', evt => {
    if (!dragImgTarget || !parentLinkNode) return;
    const selectedNode = editor.selection.getNode();
    if (selectedNode.parentNode.nodeName !== 'A') {
      editor.undoManager.transact(() => {
        const bm = editor.selection.getBookmark();
        parentLinkNode.innerHTML = dragImgTarget.outerHTML;
        editor.dom.replace(parentLinkNode, selectedNode);
        editor.selection.moveToBookmark(bm);
        evt.preventDefault();
        evt.stopPropagation();
      });
    }
    dragImgTarget = null;
    parentLinkNode = null;
  });
  const updateAlignment = getLayoutChangeHandlerV2(editor);
  editor.on('hsAlignmentChange', ({
    target,
    alignment
  }) => {
    if (!isEditableImage(editor, target)) return;
    updateAlignment(target, alignment);
  });
  const updateMargin = getUpdateMarginHandler(editor);
  editor.on('hsMarginChange', ({
    target,
    margin
  }) => {
    if (!isEditableImage(editor, target)) return;
    updateMargin(target, margin);
  });
  editor.on('hsDimensionChange', ({
    target,
    dimensions = {}
  }) => {
    if (!isEditableImage(editor, target)) return;
    resizeImage(Object.assign({
      target,
      constrained: true
    }, dimensions));
  });
  if (getPluginSetting(editor, 'appName') === 'knowledge-base') {
    editor.on('ObjectSelected', evt => {
      const {
        classList,
        tagName
      } = evt.target;
      const hasResizeDisabledAlignmentClass = classList.contains(ImageAlignmentClasses[Alignments.LEFT]) || classList.contains(ImageAlignmentClasses[Alignments.RIGHT]);
      if (hasResizeDisabledAlignmentClass && tagName === 'IMG') {
        evt.preventDefault();
      }
    });
  }
  const debouncedOpenDisallowedImageUploadAlert = debounce(() => {
    openDisallowedImageUploadAlert();
    trackInteraction(editor, 'tinymceEdit', AUTOMATIC_IMAGE_UPLOAD_NOT_ALLOWED);
  }, 200);
  editor.on('openDisallowedImageUploadAlert', debouncedOpenDisallowedImageUploadAlert);
}